import { Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

interface Props {
  onChange: (value: boolean) => void;
  value: boolean;
}

export function IncludeCompanyShipmentsCheckbox(props: Props) {
  const { onChange, value } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <>
      <Typography>All Shipments</Typography>
      <Checkbox checked={value} onChange={handleChange} />
    </>
  );
}
